import { useToast } from '@evisort/eds/components/Toast/hooks';
import { useEffect } from 'react';

import { registerShowToast, unregisterShowToast } from './showToast';

export function EdsToastRegistrar() {
  const { toast } = useToast();

  useEffect(() => {
    registerShowToast(toast);
    return () => unregisterShowToast();
  }, [toast]);

  return null;
}
